import React, { Component } from "react";
import { AuthLogin } from "../../services/auth-service";
import { app } from "../..";
import { gendropdownquery, genwoddrop } from "../../services/gendropdown";
import {
  createservice,
  updateservice,
  deleteservice,
} from "../../services/crudservice";
import { RealTimeFind } from "../../services/realtimeservice";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { closemodal } from "../../actions/modal-handler";
import {
  Icon,
  Modal,
  Header,
  Input,
  Form,
  Button,
  Dropdown,
  Label,
  Image,
  Tab,
  Table,
  Checkbox,
} from "semantic-ui-react";
import moment from "moment";
import Roundy from "../../services/roundy";
class MatEntryModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      matentry: {
        workordernumber: props.wod ? props.wod.workOrderNbr : "",
        description: props.wod ? props.wod.description : "",
        matnumber: null,
        datepurchased: moment().format("YYYY-MM-DD"),
        entrytype: "0",
        matname: "",
        amount: 0,
        tssent: null,
        wedate: moment()
          .endOf("isoWeek")
          .format("YYYY-MM-DD"),
        markuppercent: null,
      },
      reservematentry: {
        workordernumber: null,
        description: "",
        matnumber: null,
        datepurchased: moment().format("YYYY-MM-DD"),
        entrytype: "0",
        matname: "",
        amount: 0,
        tssent: null,
        wedate: moment()
          .endOf("isoWeek")
          .format("YYYY-MM-DD"),
        markuppercent: null,
      },
      activeIndex: 0,
      editing: false,
      assignment: null,
      markuppercent: null,
      matnumoptions: [],
      moveMat: true,
      materialsarray: null,
    };
  }

  genmarkupprice() {
    if (this.state.matentry.markuppercent) {
      console.log(this.state.markuppercent);
      return Roundy(
        this.state.matentry.markuppercent * this.state.matentry.amount
      );
    } else {
      return this.state.matentry.amount;
    }
  }
  componentDidUpdate(prevProps, prevState) {
    console.log("tnm", this.state.tnm, "invoice", this.state.invoice);
    // if (prevProps.materials.length !== this.props.materials.length) {
    // }
    console.log(this.props.wonum);
  }
  handlecreatemat(update) {
    let tempmat = {
      ...this.state.matentry,
      createdBy: this.props.myinfo.empnumber,
      tmnumber:
        !this.state.matentry.tmnumber && this.state.tnm
          ? this.state.tnm.tmnumber.toString()
          : this.state.matentry.tmnumber,
      invoicenumber:
        !this.state.matentry.invoicenumber && this.state.invoice
          ? this.state.invoice.number.toString()
          : this.state.matentry.invoicenumber,
    };
    console.log("tnm", this.state.tnm, "invoice", this.state.invoice);
    let newamount = tempmat.markuppercent
      ? tempmat.amount * tempmat.markuppercent
      : tempmat.amount;
    console.log("updatetnm newamount", newamount);

    var matchargediff;
    if (update) {
      var oldmat = this.props.mats.find((mat) => mat.id === tempmat.id);
      console.log("updatetnm oldmat", oldmat.amount);

      let oldamount = oldmat.markuppercent
        ? oldmat.amount * oldmat.markuppercent
        : oldmat.amount;
      matchargediff = newamount - oldamount;
      this.updateTNMInv(tempmat, matchargediff);
      updateservice("dailymaterialentries", tempmat, tempmat.id).then(() =>  this.props.update());
    } else {
      this.updateTNMInv(tempmat, newamount);
      createservice("dailymaterialentries", tempmat)
        .then((response) => {
          this.setState({ matentry: this.state.reservematentry });
          // this.props.addmat(response);
          this.props.update();
        })
        .catch((err) => console.log("mat error", err));
    }
  }
  updateTNMInv(tempmat, matchargediff, forcererender) {
    console.log("updatetnm charge", matchargediff);
    if (this.state.tnm && this.state.moveMat) {
      console.log("updatetnm old total", this.state.tnm.amount);
      updateservice(
        "tmsheets",
        {
          ...this.state.tnm,
          materialfee: this.state.tnm.materialfee + matchargediff,
          amount: this.state.tnm.amount + matchargediff,
        },
        this.state.tnm.id
      ).then((response) => {});
    }
    if (this.state.invoice && this.state.moveMat) {
      console.log("updateinvoice old total", this.state.invoice.amount);
      updateservice(
        "invoices",
        {
          ...this.state.invoice,
          amount: this.state.invoice.amount + matchargediff,
        },
        this.state.invoice.id
      ).then((response) =>
        console.log("updateinvoice new total", response.amount)
      );
    }
  }
  handlematselect(matnum) {
    console.log(matnum);
    let temptry = this.state.matentry;
    let mat = this.state.matnumoptions.find((m) => m.value === matnum);

    temptry.matname = mat.text;
    temptry.matnumber = mat.value;
    this.setState({ matentry: temptry });
  }

  genassignwod() {
    if (this.props.assignedjobs) {
      return this.props.assignedjobs.map((job) => {
        return {
          key: job.id,
          value: job,
          text: job.assigned_task + " " + job.workorder.description,
        };
      });
    }
  }
  genmarkupoptions() {
    let markupoptions = [
      {
        key: 0,
        value: "1",
        text: "0%",
      },
    ];
    for (var i = 0.5; i <= 100; i += 0.5) {
      let option = {
        key: i,
        value: i / 100 + 1,
        text: i + "%",
      };
      markupoptions = markupoptions.concat(option);
    }
    return markupoptions;
  }
  genwonuminput(matEntry) {
    if (!this.props.wod) {
      let wodnumoptions = this.genassignwod(this.props.wods);
      return (
        <Form.Field>
          <label>Work Order Number</label>
          <Dropdown
            search
            selection
            fluid
            value={this.state.assignment}
            options={wodnumoptions}
            onChange={(e, { value }) => {
              let matEntry = this.state.matentry;
              console.log(value);
              matEntry.workordernumber = value.assigned_task;
              matEntry.description = value.workorder.description;
              this.setState({ matentry: matEntry, assignment: value });
            }}
            placeholder="Workorder Number"
          />
        </Form.Field>
      );
    } else {
      if (
        !this.state.matentry.workordernumber ||
        !this.state.matentry.description
      ) {
        let tempmat = this.state.matentry;
        tempmat.workordernumber = this.props.wod.workOrderNbr;
        tempmat.description = this.props.wod.description;
        console.log('New Wod', tempmat)
      }

      return (
        <Form.Field>
          <label>Work Order Number</label>
          <Label>
            <h5>{this.props.wod.workOrderNbr}</h5>
          </Label>
        </Form.Field>
      );
    }
  }
  gensubmitbtn() {
    if (this.state.editing) {
      return (
        <Button
          color="green"
          onClick={() => {
            this.handlecreatemat(true);
            this.setState({
              editing: false,
            });
          }}
          inverted
        >
          <Icon name="checkmark" /> Update Material
        </Button>
      );
    } else {
      return (
        <Button
          color="green"
          disabled={
            !this.state.matentry.workordernumber ||
            !this.state.matentry.matnumber ||
            !this.state.matentry.amount
          }
          onClick={() => {
            this.handlecreatemat();
            //this.props.closemodal();
          }}
          inverted
        >
          <Icon name="checkmark" /> Submit
        </Button>
      );
    }
  }
  genheader() {
    if (!this.props.mobile && this.state.matentry.description) {
      return (
        "for " +
        this.state.matentry.workordernumber +
        " " +
        this.state.matentry.description
      );
    }
  }
  genCloseBtn() {
    if (this.props.mobile) {
      return (
        <Button
          color="red"
          onClick={() => {
            this.props.closemodal();
          }}
          inverted
        >
          <Icon name="close" /> Cancel
        </Button>
      );
    }
  }
  genmoveMat() {
    if (this.state.tnm) {
      return (
        <Form.Field>
          <label>
            {"Update TNM" + (this.state.invoice ? " and Invoice" : "")}
          </label>
          <Checkbox
            checked={this.state.moveMat}
            onChange={(e, { value }) => {
              this.setState({ moveMat: !this.state.moveMat });
            }}
          />
        </Form.Field>
      );
    }
  }
  populateMat(matentry) {
    var invoice = null;
    var tnm = null;
    if (matentry.tmnumber) {
      tnm = this.props.tnmlist.find(
        (tnm) =>
          tnm.tmnumber === parseInt(matentry.tmnumber) &&
          tnm.workordernumber === matentry.workordernumber
      );
    } else if (matentry.wedate) {
      tnm = this.props.tnmlist.find(
        (tnm) =>
          tnm.wedate === matentry.wedate &&
          tnm.workordernumber === matentry.workordernumber
      );
    }
    if (tnm) {
      invoice = this.props.invlist.find(
        (inv) => inv.number === parseInt(tnm.invoicenumber)
      );
    }
    if (!this.state.activeIndex) {
      this.setState({ matentry, tnm, invoice });
      //console.log('updatetnm', tnm);
    } else {
      return { tnm, invoice };
    }
  }
  gencreateform() {
    let matEntry = this.state.matentry;
    let payments = [null, "American Express", "Cash", "Check", "Wire Transfer"];
    const payment_types = payments.map((p) => {
      return { key: p, value: p, text: p };
    });
    let markupoptions = this.genmarkupoptions();
    let today = moment().format("YYYY-MM-DD");
    let matnumoptions = gendropdownquery(
      "matnumber",
      "materials",
      "companyname",
      "matnumber"
    ).then((array) => {
      if (!this.state.matnumoptions.length) {
        console.log(array);
        this.setState({ matnumoptions: array });
      }
    });
    return (
      <Form>
        <Form.Group widths="equal">
          <Form.Field>
            <label>Material Name/Supplier</label>
            <Dropdown
              search
              selection
              fluid
              value={this.state.matentry.matnumber}
              options={this.state.matnumoptions}
              onChange={(e, { value }) => {
                this.handlematselect(value);
              }}
              placeholder="Home Depot"
            />
          </Form.Field>
          {this.genwonuminput(matEntry)}
          {this.genmoveMat()}
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field>
            <label>Payment Type</label>
            <Dropdown
              search
              selection
              fluid
              value={this.state.matentry.payment_type}
              options={payment_types}
              onChange={(e, { value }) => {
                this.setState({
                  matentry: { ...this.state.matentry, payment_type: value },
                });
              }}
              placeholder="Check"
            />
          </Form.Field>
          <Form.Field />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field>
            <label>Amount</label>
            <Input
              label="$"
              type="number"
              placeholder="Amount"
              type="number"
              value={this.state.matentry.amount}
              onChange={(e) => {
                matEntry.amount = e.target.value;
                this.setState({ matentry: matEntry });
              }}
            />
          </Form.Field>
          <Form.Field>
            <label>Markup price: ${this.genmarkupprice()}</label>
            <Dropdown
              selection
              search
              fluid
              value={this.state.matentry.markuppercent}
              options={markupoptions}
              onChange={(e, { value }) => {
                console.log(value);
                matEntry.markuppercent = value;
                this.setState({
                  markuppercent: value,
                  matentry: matEntry,
                });
              }}
              placegenCloseBtnholder="%"
            />
          </Form.Field>

          <Form.Field>
            <label>Date Purchased</label>
            <Input
              type="date"
              placeholder="MM/DD/YYYY"
              value={this.state.matentry.datepurchased}
              onChange={(e) => {
                matEntry.datepurchased = moment(e.target.value).format(
                  "YYYY-MM-DD"
                );
                matEntry.wedate = moment(e.target.value)
                  .endOf("isoWeek")
                  .format("YYYY-MM-DD");
                this.populateMat(matEntry);
              }}
            />
          </Form.Field>
        </Form.Group>
      </Form>
    );
  }

  removeMat(mat) {
    let tnminv = this.populateMat(mat);
    let matcharge = mat.markuppercent
      ? mat.amount * mat.markuppercent
      : mat.amount;
    this.setState(tnminv, () => this.updateTNMInv(mat, -matcharge));

    deleteservice("dailymaterialentries", mat.id).then(() =>
     this.props.update()
    );
  }
  matrows() {
    if (this.props.mats && this.props.mats.length) {
      return this.props.mats.map((mat) => {
        return (
          <Table.Row>
            <Table.Cell>{mat.matname}</Table.Cell>
            <Table.Cell>${mat.amount}</Table.Cell>
            <Table.Cell>{mat.datepurchased}</Table.Cell>
            <Table.Cell>
              <Button
                icon
                info
                size="tiny"
                onClick={() =>
                  this.setState(
                    {
                      activeIndex: 0,
                      editing: true,
                    },
                    () => this.populateMat(Object.assign({}, mat))
                  )
                }
              >
                <Icon name="pencil" />
              </Button>
              <Button icon size="tiny" onClick={() => this.removeMat(mat)}>
                <Icon name="cancel" />
              </Button>
            </Table.Cell>
          </Table.Row>
        );
      });
    } else {
      return (
        <Table.Row>
          <Table.Cell colSpan={3}>No known materials.</Table.Cell>
        </Table.Row>
      );
    }
  }

  handleTabChange = (e, { activeIndex }) => this.setState({ activeIndex });
  handletabprop() {
    let datepurchased = moment().format("YYYY-MM-DD");
    let wedate = moment()
      .endOf("isoWeek")
      .format("YYYY-MM-DD");

    const panes = [
      {
        menuItem: "Enter Material",
      },
      {
        menuItem: "Edit Materials",
      },
    ];
    if (this.props.tab) {
      return (
        <Tab
          menu={{ secondary: true, pointing: true }}
          activeIndex={this.state.activeIndex}
          onTabChange={this.handleTabChange}
          panes={panes}
        />
      );
    } else {
      return <div>{this.gencreateform()}</div>;
    }
  }
  gencontent() {
    if (this.state.activeIndex) {
      return (
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>Amount</Table.HeaderCell>
              <Table.HeaderCell>Purchase Date</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>{this.matrows()}</Table.Body>
        </Table>
      );
    } else {
      return <div>{this.gencreateform()}</div>;
    }
  }
  render() {
    let matEntry = this.state.matentry;
    return (
      <div className="MatEntryModal">
        <Modal
          open={this.props.showModal}
          onClose={() => {
            this.props.closemodal();
          }}
          closeOnEscape
          closeOnRootNodeClick
          size="large"
        >
          <Header as="h2">
            <Image
              src={require("./edf_logo.bmp")}
              size="small"
              id="loginheader"
            />
            Enter Material Charge {this.genheader()}
          </Header>
          <Modal.Content>
            {this.handletabprop()} {this.gencontent()}
          </Modal.Content>
          <Modal.Actions>
            {this.genCloseBtn()}
            <Button
              inverted
              color="blue"
              disabled={this.state.activeIndex}
              onClick={() => {
                let wonum = this.props.wod.workOrderNbr
                  ? this.props.wod.workOrderNbr
                  : null;

                this.setState(
                  {
                    editing: false,
                  },
                  () =>
                    this.populateMat({
                      ...this.state.reservematentry,
                      workordernumber: wonum,
                    })
                );
              }}
            >
              Reset/ New Entry
            </Button>
            {this.gensubmitbtn()}
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    materials: state.materials.all,
    showModal: state.modal === "matentry",
    wods: state.workorders.derivitives,
    myinfo: state.myinfo.employeeinfo,
    assignedjobs: state.myinfo.myassignments,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      closemodal: closemodal,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(MatEntryModal);



// WEBPACK FOOTER //
// ./src/components/shared-components/matentrymodal.js